import { useRouter } from 'next/router'

import { GrowthCategory } from '@mc/api'
import { paths } from '@mc/paths'

import { CategoryPageCategoryButton } from './CategoryPageCategoryButton'
import { useContextualBrowseEnabled } from '../hooks/useContextualBrowseEnabled'
import { SubcategoryPageCategoryButton } from './SubcategoryPageCategoryButton'
import { CMPageCategoryButton } from './CMPageCategoryButton'

interface CategoryButtonProps {
  children: React.ReactNode
  category: GrowthCategory
  order: number
}

export const CategoryButtonWrapper = ({
  children,
  ...props
}: CategoryButtonProps) => {
  const { enabled } = useContextualBrowseEnabled()
  const router = useRouter()

  if (!enabled) return children

  if (router.pathname.includes(paths.category(''))) {
    return <CategoryPageCategoryButton {...props} />
  }

  if (router.pathname.includes(paths.subcategoryPage(''))) {
    return <SubcategoryPageCategoryButton {...props} />
  }

  if (
    router.pathname.includes(paths.classPage('')) ||
    router.pathname.includes(paths.seriesPage(''))
  ) {
    return <CMPageCategoryButton {...props} />
  }

  return children
}
